import { AssetTypeEnums } from '@/const/constants'

/**
   * @description 小区项目
   */
export const communityProject = 'ZCLX-FYGL-XQXM'
/**
   * @description 其他公共资源
   */
export const otherPublicResources = 'ZCLX-FYGL-XQXM-QTGGZY'
/**
  * @description 住户类型
  */
export const householdTypeDictionary = 'KH-JTCYLX'
/**
  * @description 用户类型
  */
export const userTypeDictionary = 'YHLX'
/**
  * @description 房屋类型
  */
export const houseDictionary = AssetTypeEnums.HOUSE.value
/**
  * @description 图片类型
  */
export const pictureTypeList = ['image/jpg', 'image/png', 'image/jpeg']
/**
 * @description 永久授权时间
 */
export const permanentAuthorizationTime = 253370736000000
/**
  * @description 非住户类型
  */
export const nonResidentTypeDictionary = 'YHLX-FZHLX'
/**
 * @description 房屋模板
 */
export const houseTemplate = [{
  '项目*': '南京印长江',
  '楼幢': '1号楼',
  '单元': '3单元',
  '楼层': '1楼',
  '房屋': '1101',
  '其他公共资源': '',
  '注释': '房源信息表（*为必填）；项目为当前房源根节点；填写单元必须填写楼幢；填写楼层必须填写单元、楼幢；每条数据房屋和其他公共资源选择填一个。（示例文字请在导入前删除）'
}]
/**
  * @description 房屋模板Title
  */
export const houseTemplateTitle = {
  'project': '项目*',
  'building': '楼幢',
  'unit': '单元',
  'floor': '楼层',
  'houses': '房屋',
  'other': '其他公共资源',
  'msg': '注释'
}
/**
 * @description 住户模板
 */
export const householdTemplate = [{
  '姓名*': '张三',
  '手机号*': '19999999999',
  '性别*': '男',
  '证件号码': '333333333333333333',
  '项目*': '北京江山樾',
  '楼幢': '1栋',
  '单元': '2单元',
  '楼层': '3楼',
  '房屋*': '102',
  '人员类型*': '租客',
  '授权开始时间*': '20**年**月**日',
  '授权结束时间*': '永久',
  '注释': '客户信息表（*为必填）；建议每次上传最多1000条数据；有效期永久请在"授权结束时间*"填写永久。（示例文字请在导入前删除）'
}]

/**
  * @description APP应用类型
  */
export const appTypes = 'APPYYLX'

/**
  * @description 环境监测类型
  */
export const environmental = ['HUMI', 'NS', 'PM2.5', 'PM10', 'TVOC']
